import { useCallback, useRef } from 'react';

import { trackView } from '../../logger/Logger';

export function useViewEvents() {
    const hasLogged = useRef(new Set<string>());

    const trackViewOnce = useCallback((viewName: string) => {
        if (!hasLogged.current.has(viewName)) {
            hasLogged.current.add(viewName);
            trackView(viewName);
        }
    }, []);

    return { trackViewOnce };
}
